import React from 'react'
import "../CSS/Template/Navbar.css"
import { Link } from "react-router-dom";
import navimg from "../Images/Favicons/menu.png"
import nav2img from "../Images/Favicons/cross.png"

export default function Navbar() {
  let mainList = document.getElementById("ulList")
  let navToogle = function () {
    if (mainList.style.display === "flex") {
      mainList.style.display = "none"
      document.querySelector("img").src = navimg
    }
    else {
      mainList.style.display = "flex"
      document.querySelector("img").src = nav2img
    }
  }
  return (
    <nav id='mainNav'>
      <ul id='ulList'>
        <Link className='aList' to="/">Home</Link>
        <Link className='aList' to="/Projects">Projects</Link>
        <Link className='aList' to="/Blog">Blog</Link>
        <Link className='aList' to="/Contact">Contact Me</Link>
        <Link className='aList' to="/About">About Me</Link>
        <Link className='loginFB' to="/Login-Page">Login</Link>
      </ul>
      {/* <i id='navToggle' style={{ fontSize: "24px", color: "white" }} className="fa" onClick={navToogle}>&#xf0c9;</i> */}
      <img id="navToggle" src={navimg} onClick={navToogle} alt="load" />
      <Link to="/" style={{textDecoration:"none"}}><h1 id='NavH1'><span style={{ color: "greenyellow" }}>C</span>ode <span style={{ color: "red" }}>A</span>rindam</h1></Link>
    </nav>
  )
}
